import { Injectable } from '@angular/core';
import { HttpParams, HttpResponse } from '@angular/common/http';
import { LineAbstractService } from '~/services/api/web/line/lineAbstractService';
import { HttpClientWrapper } from '~/services/api/httpClientWrapper';
import { ResponseModel } from '~/models/responseModel';
import { LineModel } from '~/models/lineModel';
import { ClipModel } from '~/models/clipModel';
import { Observable } from 'rxjs';
import { BaleModel } from '~/models/baleModel';
import { BaseWebService } from '~/services/api/web/base/baseWebService';
import { map as _map } from 'lodash';
import { forEach as _forEach } from 'lodash';
import { LineReorderModel } from 'src/app/models/lineReorderModel';
import { EntityModel } from '~/models/entityModel';
import { BrandModel } from '~/models/brandModel';
import { BaleSummaryModel } from '~/models/baleSummaryModel';
import { MobSummaryModel } from '~/models/mobSummaryModel';
import { SpeciSummaryModel } from '~/models/speciSummaryModel';
import { ClipSummaryModel } from '~/models/clipSummaryModel';
import { BreakDownModel, MobBreakDownModel } from '~/models/breakDownModel';

@Injectable()
export class LineService extends BaseWebService implements LineAbstractService {

    public static readonly PATH:string = '/lines';

    constructor(http: HttpClientWrapper) {
        super(http);
    }

    public getLines(entity?: EntityModel, brand?: BrandModel): Observable<ResponseModel> {
        let url:string = LineService.URL + LineService.PATH;

        let params = new HttpParams();
        if (entity && entity.entityId) {
            params = params.append('entityId', entity.entityId.toString());
        }

        if (brand && brand.brandId) {
            params = params.append('brandId', brand.brandId.toString());
        }

        let options:{} = {
            params: params
        };

        return this.http.get(url, options, (response: HttpResponse<any>) => {
            return _map(response['data'], (line) => new LineModel(line));
        });
    }

    public getLineById(lineId: number): Observable<ResponseModel> {
        let url:string = LineService.URL + LineService.PATH + '/' + lineId.toString();

        let options:{} = {};

        return this.http.get(url, options, (response: HttpResponse<any>) => {
            return new LineModel(response['data']);
        });
    }

    public getBalesByLineId(lineId: number): Observable<ResponseModel> {
        let url:string = LineService.URL + LineService.PATH + '/' + lineId.toString() + '/bales';

        let options:{} = {};

        return this.http.get(url, options, (response: HttpResponse<any>) => {
            return _map(response['data'], (bale) => new BaleSummaryModel(bale));
        });
    }

    public getMobsByLineId(lineId: number): Observable<ResponseModel> {
        let url:string = LineService.URL + LineService.PATH + '/' + lineId.toString() + '/mobs';

        let options:{} = {};

        return this.http.get(url, options, (response: HttpResponse<any>) => {
            return _map(response['data'], (mob) => new MobSummaryModel(mob));
        });
    }

    public getSpecisByLineId(lineId: number): Observable<ResponseModel> {
        let url:string = LineService.URL + LineService.PATH + '/' + lineId.toString() + '/specie';

        let options:{} = {};

        return this.http.get(url, options, (response: HttpResponse<any>) => {
            return _map(response['data'], (specie) => new SpeciSummaryModel(specie));
        });
    }

    public getClipsByLineId(lineId: number): Observable<ResponseModel> {
        let url:string = LineService.URL + LineService.PATH + '/' + lineId.toString() + '/clip';

        let options:{} = {};

        return this.http.get(url, options, (response: HttpResponse<any>) => {
            return _map(response['data'], (clip) => new ClipSummaryModel(clip));
        });
    }

    public getLineAverage(lineId: number): Observable<ResponseModel> {
        let url:string = LineService.URL + LineService.PATH + '/' + lineId.toString() + '/average';

        let options:{} = {};

        return this.http.get(url, options, (response: HttpResponse<any>) => {
            return new BreakDownModel(response['data']);
        });
    }

    public getMobBreakDownByLine(lineId: number): Observable<ResponseModel> {
        let url:string = LineService.URL + LineService.PATH + '/' + lineId.toString() + '/mob-breakdown';

        let options:{} = {};

        return this.http.get(url, options, (response: HttpResponse<any>) => {
            return _map(response['data'], (model:{}) => new MobBreakDownModel(model));
        });
    }

}
